<template>
  <div>
    <v-breadcrumbs :items="items" large></v-breadcrumbs>
  </div>
</template>

<script>
const routerMap = {
  dashboard: { title: '首頁' },
  member: { title: '會員管理' },
  'member-list': { title: '會員列表', parent: 'member' },
  'member-create': { title: '建立', parent: 'member-list' },
  'member-edit': {
    title: (route) => `明細_${route.params.userId}`,
    parent: 'member-list',
  },
  'member-points': { title: '點數紀錄頁', parent: 'member-edit' },
  'member-smslog': { title: '簡訊紀錄', parent: 'member-edit' },
  'member-signInLogs': { title: '登入記錄', parent: 'member-edit' },
  'member-auth-list': { title: '待審核名單', parent: 'member' },
  'member-auth': { title: '審查', parent: 'member-auth-list' },
  'swap-in-point': { title: '點數換入管理' },
  'swap-in-point-type-management': {
    title: '換入類別管理',
    parent: 'swap-in-point',
  },
  'swap-in-point-item-list': { title: '換入點數列表', parent: 'swap-in-point' },
  'swap-in-point-item-list-create': { title: '新增換入點數', parent: 'swap-in-point-item-list' },
  'swap-in-point-item-list-edit': { title: '修改換入點數', parent: 'swap-in-point-item-list' },
  'swap-in-point-vouchers-list': { title: '換入序號管理', parent: 'swap-in-point' },
  swapInPointVoucherImport: { title: '匯入序號', parent: 'swap-in-point-vouchers-list' },
  swapInPointVoucherCreate: { title: '新增序號', parent: 'swap-in-point-vouchers-list' },
  swapInPointVoucherEdit: { title: '序號狀態設定', parent: 'swap-in-point-vouchers-list' },
  'swap-out-point': { title: '點數換出管理' },
  'swap-out-point-supplier': { title: '供應商管理', parent: 'swap-out-point' },
  swapOutProductCategoryList: {
    title: '換出類別管理',
    parent: 'swap-out-point',
  },
  swapOutProductCategoryCreate: {
    title: '新增換出類別',
    parent: 'swapOutProductCategoryList',
  },
  swapOutProductCategoryEdit: {
    title: '修改換出類別',
    parent: 'swapOutProductCategoryList',
  },
  swapOutProductTagList: {
    title: '商品標籤管理',
    parent: 'swap-out-point',
  },
  swapOutProductTagCreate: {
    title: '新增標籤',
    parent: 'swapOutProductTagList',
  },
  swapOutProductTagEdit: {
    title: '修改標籤',
    parent: 'swapOutProductTagList',
  },
  tagApplyProducts: {
    title: '適用商品',
    parent: 'swapOutProductTagList',
  },
  swapOutProduct: {
    title: '換出商品管理',
    parent: 'swap-out-point',
  },
  swapOutProductList: {
    title: '商品列表',
    parent: 'swapOutProduct',
  },
  swapOutProductCreate: {
    title: '新增品項',
    parent: 'swapOutProductList',
  },
  swapOutProductEdit: {
    title: '修改品項',
    parent: 'swapOutProductList',
  },
  swapOutProductVoucherList: {
    title: '換出序號查詢',
    parent: 'swapOutProductList',
  },
  swapOutProductVoucherCreate: {
    title: '新增序號',
    parent: 'swapOutProductVoucherList',
  },
  swapOutProductVoucherImport: {
    title: '匯入序號',
    parent: 'swapOutProductVoucherList',
  },
  swapOutProductVoucherEdit: {
    title: '序號狀態設定',
    parent: 'swapOutProductVoucherList',
  },
  swapOutVoucherList: {
    title: '序號資訊',
    parent: 'swap-out-point',
  },
  news: { title: '媒體報導管理' },
  'news-list': { title: '新聞列表', parent: 'news' },
  'news-edit': { title: '新聞修改', parent: 'news-list' },
  'news-create': { title: '新增新聞', parent: 'news-list' },
  'news-media-list': { title: '媒體設定', parent: 'news' },
  event: { title: '最新活動管理' },
  'event-list': { title: '活動列表', parent: 'event' },
  'event-edit': { title: '活動修改', parent: 'event-list' },
  'event-create': { title: '新增活動', parent: 'event-list' },
  promotion: { title: '優惠代碼管理' },
  'promotion-code-list': { title: '優惠代碼管理' },
  'promotion-code-create': {
    title: '新增優惠代碼',
    parent: 'promotion-code-list',
  },
  'promotion-code-edit': {
    title: '優惠代碼修改',
    parent: 'promotion-code-list',
  },
  virtual: { title: '虛擬貨幣交易管理' },
  virtualCurrency: { title: '虛擬貨幣列表', parent: 'virtual' },
  virtualCurrencyCreate: { title: '新增虛擬貨幣', parent: 'virtualCurrency' },
  virtualCurrencyEdit: { title: '修改虛擬貨幣', parent: 'virtualCurrency' },
  virtualExchanger: { title: '交易所列表', parent: 'virtual' },
  virtualExchangerCreate: { title: '新增交易所', parent: 'virtualExchanger' },
  virtualExchangerEdit: { title: '修改交易所', parent: 'virtualExchanger' },
  exchangerCurrency: { title: '可交易虛擬貨幣列表', parent: 'virtualExchanger' },
  exchangerCurrencyCreate: { title: '新增交易所虛擬貨幣', parent: 'exchangerCurrency' },
  exchangerCurrencyEdit: { title: '修改交易所虛擬貨幣', parent: 'exchangerCurrency' },
  dailyThreshold: { title: '設定每日交易門檻', parent: 'virtual' },
  'merchant-layout': { title: '供應商管理' },
  merchant: { title: '列表', parent: 'merchant-layout' },
  merchantCreate: { title: '新增供應商', parent: 'merchant' },
  merchantEdit: { title: '修改供應商', parent: 'merchant' },
  merchantannouncement: { title: '公告', parent: 'merchant' },
  merchantCategoryList: { title: '供應商類別管理', parent: 'merchant-layout' },
  scheduledMessageList: { title: '排程推播列表' },
  scheduledMessageCreate: { title: '新增推播訊息', parent: 'scheduledMessageList' },
  scheduledMessageEdit: { title: '修改推播訊息', parent: 'scheduledMessageList' },
  shoppingGuideList: { title: '導購列表' },
  shoppingGuideCreate: { title: '新增', parent: 'shoppingGuideList' },
  shoppingGuideEdit: { title: '修改', parent: 'shoppingGuideList' },
  serviceUpdateList: { title: '服務更新' },
  serviceUpdateCreate: { title: '新增', parent: 'serviceUpdateList' },
  serviceUpdateEdit: { title: '修改', parent: 'serviceUpdateList' },
  invitationCodeList: { title: '推薦代碼管理' },
  invitationCodeCreate: { title: '新增推薦代碼', parent: 'invitationCodeList' },
  invitationCodeEdit: { title: '修改推薦代碼', parent: 'invitationCodeList' },
  shoppingGiveBack: { title: '登記回饋活動' },
  shoppingGiveBackMerchantList: { title: '合作廠商管理', parent: 'shoppingGiveBack' },
  shoppingGiveBackMerchantEdit: { title: '編輯', parent: 'shoppingGiveBackMerchantList' },
  shoppingGiveBackMerchantCreate: { title: '新增', parent: 'shoppingGiveBackMerchantList' },
  shoppingGiveBackRequest: { title: '登記回饋查詢', parent: 'shoppingGiveBack' },
  storeList: { title: '店家管理', parent: 'merchant' },
  storeAdminList: { title: '店家管理人員管理', parent: 'storeList' },
  storeSummary: { title: '店家每日消費查詢' },
  paymentList: { title: '訂單管理' },
  pointCalculatorList: { title: '點數計算機管理', parent: 'swap-in-point' },
  pointCalculatorCreate: { title: '新增', parent: 'pointCalculatorList' },
  pointCalculatorEdit: { title: '修改', parent: 'pointCalculatorList' },
  report: { title: '行銷報表管理' },
  swapOutPointReport: { title: '換出點數', parent: 'report' },
  swapOutProductReport: { title: '換出商品（純點）', parent: 'report' },
  swapOutDiscountCouponReport: { title: '折價券使用列表', parent: 'report' },
  mobilePaymentReport: { title: '線上電支明細（點＋金）', parent: 'report' },
  userPointReport: { title: '會員點數列表', parent: 'report' },
  swapInReport: { title: '會員換入點數', parent: 'report' },
  superPointGenerateReport: { title: 'SP點數產出紀錄', parent: 'report' },
  otherPointList: { title: '其他點數管理' },
  otherPointEdit: { title: '修改', parent: 'otherPointList' },
  otherPointActivityList: { title: '其他點數活動列表', parent: 'otherPointList' },
  otherPointActivityCreate: { title: '其他點數活動新增', parent: 'otherPointActivityList' },
  otherPointActivityEdit: { title: '其他點數活動編輯', parent: 'otherPointActivityList' },
  bannerList: { title: 'Web首頁橫幅列表' },
  bannerCreate: { title: '新增', parent: 'bannerList' },
  bannerEdit: { title: '修改', parent: 'bannerList' },
  homeProduct: { title: 'Web首頁顯示產品管理' },
  appAdPopupList: { title: 'APP首頁彈窗廣告列表' },
  appAdPopupCreate: { title: '新增首頁彈窗廣告', parent: 'appAdPopupList' },
  appAdPopupEdit: { title: '編輯首頁彈窗廣告', parent: 'appAdPopupList' },
  appAdCarouselList: { title: 'APP首頁廣告版位列表' },
  appAdCarouselCreate: { title: '新增首頁廣告版位', parent: 'appAdCarouselList' },
  appAdCarouselEdit: { title: '編輯首頁廣告版位', parent: 'appAdCarouselList' },
  couponActivityList: { title: '折價券活動列表' },
  couponActivityCreate: { title: '折價券活動新增', parent: 'couponActivityList' },
  couponActivityEdit: { title: '折價券活動編輯', parent: 'couponActivityList' },
  popularProductUrlList: { title: 'APP首頁人氣兌換列表' },
  popularProductUrlCreate: { title: '新增首頁人氣兌換', parent: 'popularProductUrlList' },
  popularProductUrlEdit: { title: '修改首頁人氣兌換', parent: 'popularProductUrlList' },
  missionList: { title: '任務列表' },
  missionCreate: { title: '新增任務', parent: 'missionList' },
  missionEdit: { title: '修改任務', parent: 'missionList' },
};
export default {
  data: () => ({
    items: [
      {
        text: 'Dashboard',
        disabled: false,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Link 1',
        disabled: false,
        href: 'breadcrumbs_link_1',
      },
      {
        text: 'Link 2',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
  }),
  mounted() {
    this.changeRouter();
  },
  watch: {
    '$route.path': function routeChanged() {
      this.changeRouter();
    },
  },
  methods: {
    changeRouter() {
      const { name, params, href } = this.$route;
      const items = [];
      let current = name;
      let currentHref = href;
      do {
        const currentMap = routerMap[current];
        if (currentMap === undefined) return;
        const { title, parent } = currentMap;
        const text = typeof title === 'function' ? title(this.$route) : title;

        const route = this.$router.resolve({ name: current, params }, this.$route);
        const pattern = /^(\/)?(.+?)(\/)?$/;
        const disabled = current === name || currentHref.replace(pattern, '$2') === route.href.replace(pattern, '$2');
        items.push({
          text,
          disabled,
          activeClass: disabled ? 'v-breadcrumbs__item--disabled' : '',
          to: { name: current, params },
        });
        current = parent;
        currentHref = route.href;
      } while (current);

      this.items = items.reverse();
    },
  },
};
</script>

<style>
.v-application ul {
  padding: 0px;
  padding-top: 12px;
}
</style>
